<div class="row"
  style="width:100%; float: right; text-align: right; margin-top: 0px; padding-top: 0px; margin-right:0px !important">
  <div class="col-11"></div>
  <div class="col-1 text-right" style="float:right; margin-right:0px; padding-right:0px;">
    <mat-icon style="float:right; cursor: pointer;" (click)="onNoClick()">cancel</mat-icon>
  </div>
</div>
<div class="row">
  <div class="col-12 div">
    <h3>{{labels.lblAddListMsg}}</h3>
  </div>
  @if (selectedFile) {
    <div class="logLabels" style="width: 100%; text-align: center;">
      <h4 style="color: #9dacd9; margin-left: 0px; font-family: 'Prompt', sans-serif !important;">
      {{selectedFile.name}}</h4>
    </div>
  }
</div>
<div class="row" style="margin-top: 15px;">

  <input type="file" (change)="onFileChanged($event)" #fileUpload style="display: none; padding: 7px;">
  @if (uploading) {
    <mat-progress-bar mode="indeterminate" style="margin-top: 10px; margin-bottom: 10px"></mat-progress-bar>
  }
  <div class="col-4 div">
    @if (!selectedFile) {
      <button mat-raised-button class="tableBtn" style="width: 100%; text-align: center;" cdkFocusInitial
      type="submit" (click)="fileUpload.click()">{{labels.lblAdd}}</button>
    }
    @if (selectedFile) {
      <button mat-raised-button class="tableBtn" style="width: 100%; text-align: center;" cdkFocusInitial
      type="submit" (click)="onSaveUsers($event)">{{labels.lblSave}}</button>
    }
  </div>
  <div class="col-4 div" style="padding: 7px;">
    <button class="tableBtn btnInstruction">
      <a class="link" target="_blank"
        href="https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/Uputstvo-converted.pdf?alt=media&token=c7125aad-d54a-4fdf-91f9-f8026e19e3c4"
      cdkFocusInitial>{{labels.lblInstruction}}</a>
    </button>
  </div>
  <div class="col-4 div" style="padding: 7px;">
    <button class="tableBtn btnInstruction">
      @if (lang=='srb' && data.flag == false) {
        <a class="link" target="_blank"
          href="https://leste.fra1.cdn.digitaloceanspaces.com/samples/template%20(1).xls">{{labels.lblTemplate}}</a>
      }
      @if (lang=='eng' && data.flag == false) {
        <a class="link" target="_blank"
          href="https://leste.fra1.cdn.digitaloceanspaces.com/samples/template%20(1).xls">{{labels.lblTemplate}}</a>
      }
      @if (lang=='srb' && data.flag == true) {
        <a class="link" target="_blank"
          href="https://leste.fra1.cdn.digitaloceanspaces.com/samples/template%20(1).xls">{{labels.lblTemplate}}</a>
      }
      @if (lang=='eng' && data.flag == true) {
        <a class="link" target="_blank"
          href="https://leste.fra1.cdn.digitaloceanspaces.com/samples/template%20(1).xls">{{labels.lblTemplate}}</a>
      }

    </button>
  </div>
</div>
